import { css } from 'styled-components'

/*
  WIDTH/HEIGHT VARIABLES
*/

export const width_height_0_5 = (width = true, height = true) => css`
  ${width ? 'width: 0.5rem;' : null}
  ${height ? 'height: 0.5rem;' : null}
`

export const width_height_0_75 = (width = true, height = true) => css`
  ${width ? 'width: 0.75rem;' : null}
  ${height ? 'height: 0.75rem;' : null}
`

export const width_height_1 = (width = true, height = true) => css`
  ${width ? 'width: 1rem;' : null}
  ${height ? 'height: 1rem;' : null}
`

export const width_height_1_5 = (width = true, height = true) => css`
  ${width ? 'width: 1.5rem;' : null}
  ${height ? 'height: 1.5rem;' : null}
`

export const width_height_2 = (width = true, height = true) => css`
  ${width ? 'width: 2rem;' : null}
  ${height ? 'height: 2rem;' : null}
`

export const width_height_2_5 = (width = true, height = true) => css`
  ${width ? 'width: 2.5rem;' : null}
  ${height ? 'height: 2.5rem;' : null}
`

export const width_height_3 = (width = true, height = true) => css`
  ${width ? 'width: 3rem;' : null}
  ${height ? 'height: 3rem;' : null}
`

export const width_height_4 = (width = true, height = true) => css`
  ${width ? 'width: 4rem;' : null}
  ${height ? 'height: 4rem;' : null}
`

export const width_height_5 = (width = true, height = true) => css`
  ${width ? 'width: 5rem;' : null}
  ${height ? 'height: 5rem;' : null}
`

export const width_height_6 = (width = true, height = true) => css`
  ${width ? 'width: 6rem;' : null}
  ${height ? 'height: 6rem;' : null}
`

export const width_height_8 = (width = true, height = true) => css`
  ${width ? 'width: 8rem;' : null}
  ${height ? 'height: 8rem;' : null}
`

export const width_height_10 = (width = true, height = true) => css`
  ${width ? 'width: 10rem;' : null}
  ${height ? 'height: 10rem;' : null}
`

export const width_height_12 = (width = true, height = true) => css`
  ${width ? 'width: 12rem;' : null}
  ${height ? 'height: 12rem;' : null}
`

export const width_height_16 = (width = true, height = true) => css`
  ${width ? 'width: 16rem;' : null}
  ${height ? 'height: 16rem;' : null}
`

export const width_height_20 = (width = true, height = true) => css`
  ${width ? 'width: 20rem;' : null}
  ${height ? 'height: 20rem;' : null}
`

export const width_height_24 = (width = true, height = true) => css`
  ${width ? 'width: 24rem;' : null}
  ${height ? 'height: 24rem;' : null}
`

export const width_height_28 = (width = true, height = true) => css`
  ${width ? 'width: 28rem;' : null}
  ${height ? 'height: 28rem;' : null}
`

export const width_height_32 = (width = true, height = true) => css`
  ${width ? 'width: 32rem;' : null}
  ${height ? 'height: 32rem;' : null}
`

export const width_height_40 = (width = true, height = true) => css`
  ${width ? 'width: 40rem;' : null}
  ${height ? 'height: 40rem;' : null}
`

export const width_height_48 = (width = true, height = true) => css`
  ${width ? 'width: 48rem;' : null}
  ${height ? 'height: 48rem;' : null}
`
